// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentResult-Error_cls1__c+OGc","cls2":"PaymentResult-Error_cls2__KcrBo PaymentResult-Error_cls1__c+OGc"};